import { NodeHistoryElement } from './NodeHistoryElement';

export class ContextActionNodeElement extends NodeHistoryElement {
  constructor() {
    super();
  }
}
